// src/services/notifications.js
import { api } from "./api";
import { getVisitorId } from "./visitor";

/**
 * Recuperer les notifications du visiteur
 */
export async function getNotifications() {
  const visitorId = getVisitorId();
  if (!visitorId) throw new Error("IDENTIFIANT_NAVIGATEUR_INDISPONIBLE");

  const { data } = await api.get(`/notifications?visitor_id=${visitorId}`);
  return data;
}

/**
 * Recuperer le nombre de notifications non lues
 */
export async function getUnreadCount() {
  const visitorId = getVisitorId();
  if (!visitorId) return 0;

  try {
    const { data } = await api.get(`/notifications/unread-count?visitor_id=${visitorId}`);
    return data.count || 0;
  } catch (error) {
    console.error("Erreur lors de la recuperation du nombre de notifications:", error);
    return 0;
  }
}

/**
 * Marquer une notification comme lue
 */
export async function markAsRead(notificationId) {
  const visitorId = getVisitorId();
  if (!visitorId) throw new Error("IDENTIFIANT_NAVIGATEUR_INDISPONIBLE");

  const { data } = await api.put(`/notifications/${notificationId}/read?visitor_id=${visitorId}`);
  return data;
}

/**
 * Marquer toutes les notifications comme lues
 */
export async function markAllAsRead() {
  const visitorId = getVisitorId();
  if (!visitorId) throw new Error("IDENTIFIANT_NAVIGATEUR_INDISPONIBLE");

  const { data } = await api.put(`/notifications/mark-all-read?visitor_id=${visitorId}`);
  return data;
}
